module.exports = __webpack_public_path__ + "static/forecraynibutcepaidkanal-fa23fb8c733c9a241d1abab23000c7b5.png";